import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  min-block-size: ${spacing(7)}; // 56px
`
export const paper = css`
  inline-size: 100%;
  max-inline-size: ${spacing(60.75)}; // 486px
  overflow: visible;
  padding: ${spacing(2)};
`
